<template lang="pug">
section.inteligencia-territorial
    BaseHeaderInteligenciaTerritorial(
        :titulo="$t('mensagens.inteligenciaTerritorial.titulo')",
        :breadcrumb='breadcrumb',
        @mudar-de-rota='mudarDeRota',
        v-loading='isLoadingAreaTotal || isLoadingRanking'
    )
    .view-container-base-header
        .margin-top
            FiltrarInteligenciaTerritorial(
                :tags='tags',
                :isLoading='isLoadingAreaTotal || isLoadingRanking',
                @remover-tag='removerTag',
                v-loading='isLoadingAreaTotal || isLoadingRanking'
            )
        .inteligencia-territorial-container
            h3 {{ $t('mensagens.inteligenciaTerritorial.visualizacaoDosDados') }}
            .inteligencia-territorial-container__button
                button(
                    v-for='(dado, index) in visualizacaoDados',
                    @click='selecionarBase(dado, index)',
                    :class="['el-button el-button--default is-round', { 'inteligencia-territorial-container__button----active': index === selectedIndex, 'is-disabled': dado === $t('mensagens.inteligenciaTerritorial.base.carteira') }]",
                    :disabled="dado === $t('mensagens.inteligenciaTerritorial.base.carteira')"
                )
                    | {{ dado }}
            .alert-dados-safra
                el-alert(:closable='false')
                    span
                        i.el-icon-warning-outline &nbsp;
                    span.textoSafra(v-if='culturaSelecionada !== "SOJA"')
                        | {{ $t('mensagens.inteligenciaTerritorial.dadosReferentesSafra2122') }}
                    span.textoSafra(v-else)
                        | {{ $t('mensagens.inteligenciaTerritorial.dadosReferentesSafraSoja2122') }}

        .secao-container--conteudo
            h3 {{ $t('mensagens.inteligenciaTerritorial.selecioneUmaCultura') }}
            .secao-container--conteudo--interno
                FiltroSelecaoCultura(
                    :titulo="$t('mensagens.inteligenciaTerritorial.cultura.soja')",
                    :totalAreaPlantada='areaTotal.areaPlantadaUltimaSafraSojaHa',
                    :class='culturaSelecionada === "SOJA" ? "filtro-cultura-ativada" : "filtro-cultura-desativada"',
                    :estaSelecionado='culturaSelecionada === "SOJA" ? true : false',
                    icone='soja',
                    v-loading='isLoadingAreaTotal || isLoadingRanking'
                )
                    slot
                        el-radio#culturaSelecionadaSoja(
                            v-model='culturaSelecionada',
                            label='SOJA',
                            :disabled='tipoRanking === "pastagem" ? true : false',
                            size='large'
                        )
        .inteligencia-territorial-container__container
            .inteligencia-territorial-container__lista
                .inteligencia-territorial-container__lista-item
                    h3 {{ $t('mensagens.inteligenciaTerritorial.imoveis') }}
                    CardInteligenciaTerritorialImoveis(:imoveis='areaTotal', v-loading='isLoadingAreaTotal')
                .inteligencia-territorial-container__lista-item
                    h3 {{ $t('mensagens.inteligenciaTerritorial.potencialAgropecuario') }}
                    CardInteligenciaTerritorialPotencialAgropecuario(
                        :potencialAgropecuario='areaTotal',
                        :tipoAreaPlantada='culturaSelecionada',
                        v-loading='isLoadingAreaTotal'
                    )
                .inteligencia-territorial-container__lista-item
                    h3 {{ $t('mensagens.inteligenciaTerritorial.restricoesSocioambientais') }}
                    CardInteligenciaTerritorialRestricoesSocioambientais(
                        :restricoesSocioambientais='areaTotal',
                        :culturaSelecionada='culturaSelecionada',
                        v-loading='isLoadingAreaTotal'
                    )

        .secao-container--conteudo
            .inteligencia-territorial-container__container
                h3 {{ prefixoTituloContainerGrafico }} {{ tituloContainerGrafico }}
                .linha__divisoria
                    RankingCategoriaInteligenciaTerritorial(
                        v-if='dadosRanking.length > 0',
                        :tipoVisao='filtroState?.tipoAgrupamento || "PAIS"',
                        :dadosRanking='dadosRanking || []',
                        :categoriasRanking='categoriasRanking || []',
                        :culturaSelecionada='culturaSelecionada',
                        :isLoadingRanking='isLoadingRanking',
                        v-loading='isLoadingRanking'
                    )
                    section.inteligencia__mapa
                        MapaInteligenciaTerritorial(
                            ref='map',
                            idMapa='MapaInteligenciaTerritorial',
                            :mapConfig='configuracoesMapa',
                            :controleCulturaMapa='controleCulturaMapa',
                            :tipoAgrupamento='filtroState?.tipoAgrupamento',
                            :siglaEstado='filtroState?.siglaEstado',
                            :idsMunicipios='filtroState?.idsMunicipios',
                            :showStatesLayers='true',
                            :menuMaior='false',
                            @setarPrimeiroCarregamento='primeiroCarregamento = true',
                            @setarLoadingRanking='isLoadingRanking = $event',
                            v-loading='isLoadingRanking'
                        )
</template>

<script>
import BaseHeaderInteligenciaTerritorial from '@/components/BaseHeaderInteligenciaTerritorial.vue';
import FiltrarInteligenciaTerritorial from '@/components/inteligenciaTerritorial/FiltrarInteligenciaTerritorial.vue';
import FiltroSelecaoCultura from '@/components/inteligenciaTerritorial/FiltroSelecaoCultura.vue';
import CardInteligenciaTerritorialImoveis from '@/components/inteligenciaTerritorial/CardInteligenciaTerritorialImoveis.vue';
import CardInteligenciaTerritorialPotencialAgropecuario from '@/components/inteligenciaTerritorial/CardInteligenciaTerritorialPotencialAgropecuario.vue';
import InteligenciaTerritorialService from '@/services/InteligenciaTerritorialService';
import MunicipioService from '@/services/MunicipioService';
import MapaInteligenciaTerritorial from '@/components/inteligenciaTerritorial/MapaInteligenciaTerritorial.vue';
import RankingCategoriaInteligenciaTerritorial from '@/components/inteligenciaTerritorial/RankingCategoriaInteligenciaTerritorial.vue';
import CardInteligenciaTerritorialRestricoesSocioambientais from '@/components/inteligenciaTerritorial/CardInteligenciaTerritorialRestricoesSocioambientais.vue';
import { mapState, mapActions } from 'vuex';
import LocalidadeService from '@/services/LocalidadeService';
import CarUtils from '@/utils/CarUtils';
import _ from 'lodash';
import EventBus from '@/utils/eventBus';

export default {
    name: 'index',
    components: {
        BaseHeaderInteligenciaTerritorial,
        FiltrarInteligenciaTerritorial,
        MapaInteligenciaTerritorial,
        CardInteligenciaTerritorialPotencialAgropecuario,
        CardInteligenciaTerritorialImoveis,
        CardInteligenciaTerritorialRestricoesSocioambientais,
        FiltroSelecaoCultura,
        RankingCategoriaInteligenciaTerritorial
    },
    data() {
        return {
            pais: 'PAIS',
            estado: 'ESTADO',
            municipio: 'MUNICIPIO',
            cultura: 'CULTURA',
            selectedIndex: 0,
            camadasMapa: [],
            controleCulturaMapa: 'area-plantada',
            configuracoesMapa: {
                controls: {
                    zoomControl: true,
                    fullscreen: true,
                    camadasControl: true,
                    sentinelHubAccess: true,
                    drawControl: true
                },
                inspecionar: true,
                diagnostico: true
            },
            culturaSelecionada: null,
            agruparPorCultura: false,
            breadcrumb: [
                { nome: this.$t('mensagens.inteligenciaTerritorial.visaoGeral'), rota: '/inteligencia-territorial' }
            ],
            tags: [],
            tituloContainerGrafico: 'por UF',
            prefixoTituloContainerGrafico: 'Ranking de Área Agricultável ',
            areaTotal: {},
            areasPlantadas: [],
            dadosRanking: [],
            categoriasRanking: [],
            estadoData: {},
            municipioData: {},
            estadoId: null,
            isLoading: false,
            isLoadingAreaTotal: true,
            isLoadingAreasPlantadas: true,
            isLoadingRanking: true,
            arrayIdsMuncipios: [],
            primeiroCarregamento: false,
            temFiltrosAvancados: false
        };
    },
    watch: {
        culturaSelecionada: {
            handler(newValue) {
                if (newValue) {
                    let filtros = {
                        ...this.filtroState,
                        codigosCulturas: newValue
                    };
                    this.globalSetterFiltros(filtros, this.filtroState?.tipoAgrupamento);
                }
            },
            immediate: false
        },
        tag: function () {
            this.tags.sort((a, b) => a.nome.localeCompare(b.nome));
        },
        filtroState: {
            deep: true,
            immediate: false,
            handler(newValue) {
                if (newValue) {
                    if (this.primeiroCarregamento) {
                        this.isLoadingAreaTotal = true;
                        this.isLoadingRanking = true;
                        this.globalSetterFiltros(this.filtroState, this.filtroState?.tipoAgrupamento);
                    }
                }
            }
        }
    },
    async created() {
        if (Object.keys(this.$route?.params).length > 0) {
            if (Object.keys(this.$route?.params).length > 0 && (this.$route?.params?.uf === 'undefined' || this.$route?.params?.uf === 'null')) {
                setTimeout(() => {
                    this.$router.push({
                        name: 'InteligenciaTerritorial'
                    });
                }, 1000);
                setTimeout(() => {
                    window.location.reload();
                }, 1500);
            }
            if (Object.keys(this.$route?.params).length > 0 && this.$route?.params?.uf !== 'undefined' && !this.$route?.params?.municipio) {
                this.primeiroCarregamento = true;
                if (this.$route?.params?.uf) {
                    await this.atualizarFiltroInicio('ESTADO');
                }
            } else if (Object.keys(this.$route?.params).length > 0 && this.$route?.params?.uf !== 'undefined' && this.$route?.params?.municipio !== 'undefined') {
                this.primeiroCarregamento = true;
                if (this.$route?.params?.uf && this.$route?.params?.municipio) {
                    await this.atualizarFiltroInicio('MUNICIPIO');
                }
            }
        } else {
            await this.filtrarAreaTotal();
        }

        EventBus.$off('inteligenciaTerritorial:remover-tag');
        EventBus.$on('inteligenciaTerritorial:remover-tag', this.removerTag);

        EventBus.$off('inteligenciaTerritorial:setar-prefixo-titulo-container-grafico');
        EventBus.$on('inteligenciaTerritorial:setar-prefixo-titulo-container-grafico', (prefixoTituloContainerGrafico) => {
            this.prefixoTituloContainerGrafico = prefixoTituloContainerGrafico;
        });

        EventBus.$off('inteligenciaTerritorial:setar-array-ids-municipios');
        EventBus.$on('inteligenciaTerritorial:setar-array-ids-municipios', (arrayIdsMuncipios) => {
            this.arrayIdsMuncipios = arrayIdsMuncipios;
        });

        EventBus.$off('inteligenciaTerritorial:atualizar-filtros-click-mapa-estados');
        EventBus.$on('inteligenciaTerritorial:atualizar-filtros-click-mapa-estados', async (uf) => {
            this.updateFiltrosClickMapaEstados(uf);
        });

        EventBus.$off('inteligenciaTerritorial:atualizar-filtros-click-mapa-municipios');
        EventBus.$on('inteligenciaTerritorial:atualizar-filtros-click-mapa-municipios', async (idMunicipio) => {
            this.updateFiltrosClickMapaMunicipios(idMunicipio);
        });

        EventBus.$off('inteligenciaTerritorial:processar-mudanca-tab');
        EventBus.$on('inteligenciaTerritorial:processar-mudanca-tab', async (tab, objTag) => {
            if (tab !== '3') {
                if (tab === '2' && objTag !== null) {
                    this.removerTag(objTag);
                } else if (tab === '2' && objTag === null) {
                    await this.globalSetterFiltros(this.filtroState, this.filtroState?.tipoAgrupamento);
                } else if (tab === '1') {
                    await this.globalSetterFiltros(this.filtroState, this.filtroState?.tipoAgrupamento);
                }
            } else if (tab === '3' && this.culturaSelecionada !== null) {
                await this.globalSetterFiltros(this.filtroState, this.filtroState?.tipoAgrupamento);
            }
        });

        EventBus.$off('inteligenciaTerritorial:atualizar-filtros-click-grafico');
        EventBus.$on('inteligenciaTerritorial:atualizar-filtros-click-grafico', async (conteudoLinhaGraficoClickGrafico, indexCategoria) => {
            await this.atualizarFiltrosClickGrafico(conteudoLinhaGraficoClickGrafico, indexCategoria);
        });

        EventBus.$off('inteligenciaTerritorial:setar-renomear-grafico-props');
        EventBus.$on('inteligenciaTerritorial:setar-renomear-grafico-props', (arr) => {
            this.renomearGraficoProps(arr);
        });
    },

    async mounted() {
        const radioButtons = document.querySelectorAll(
            'div.bloco-selecao-cultura_titulo > div.bloco-selecao-culturatitulo-icone > label > span.el-radio_label'
        );

        radioButtons.forEach(radioBtn => {
            radioBtn.style.display = 'none';
        });
    },

    beforeDestroy() {
        if (this.$route.name !== 'InteligenciaTerritorialImovel') {
            this.limparFiltros();
        }
    },

    computed: {
        ...mapState({
            filtroState: state => state.filtroInteligenciaTerritorial,
            idsMunicipiosInteligenciaTerritorialRanking: state =>
                state.idsMunicipiosInteligenciaTerritorialRanking
        }),
        tipoRanking() {
            if (
                this.prefixoTituloContainerGrafico ===
                'Ranking de Área de pastagem '
            ) {
                return 'pastagem';
            } else if (
                this.prefixoTituloContainerGrafico ===
                'Ranking de Área Agricultável '
            ) {
                return 'area-plantada-';
            } else if (
                this.prefixoTituloContainerGrafico ===
                'Ranking de Produção '
            ) {
                return 'producao-';
            }
            return 'pastagem';
        },
        visualizacaoDados() {
            return [this.$t('mensagens.inteligenciaTerritorial.base.lyra'), this.$t('mensagens.inteligenciaTerritorial.base.carteira')];
        }
    },

    methods: {
        ...mapActions(['setFiltroInteligenciaTerritorial', 'setArrayTodosMunicipiosEstadoInteligenciaTerritorial']),
        async atualizarFiltrosClickGrafico(conteudoLinhaGraficoClickGrafico, indexCategoria) {
            if (conteudoLinhaGraficoClickGrafico && conteudoLinhaGraficoClickGrafico.length === 2) {
                await this.buscarEstado(conteudoLinhaGraficoClickGrafico);

                this.tags = this.tags.filter(
                    value =>
                        value?.codigo !== this.municipio &&
                        value?.codigo !== this.estado &&
                        value?.codigo !== 'CAR'
                );
                this.tags.push({
                    id: conteudoLinhaGraficoClickGrafico,
                    nome: conteudoLinhaGraficoClickGrafico,
                    codigo: 'ESTADO'
                });
                let filtros = {
                    ...this.filtroState,
                    tipoAgrupamento: 'ESTADO',
                    objEstado: this.estadoData || {},
                    siglaEstado: conteudoLinhaGraficoClickGrafico,
                    idsMunicipios: [],
                    codigosCars: [],
                    codigosCulturas: this.culturaSelecionada
                };

                this.setFiltroInteligenciaTerritorial(filtros);
                this.atualizarTituloContainerGrafico('ESTADO');
            } else if (conteudoLinhaGraficoClickGrafico && conteudoLinhaGraficoClickGrafico.length >= 3 && conteudoLinhaGraficoClickGrafico.length <= 35) {
                await this.buscarMunicipio(this.arrayIdsMuncipios[indexCategoria]);

                this.tags = this.tags.filter(
                    value =>
                        value?.codigo !== this.estado &&
                        value?.codigo !== this.municipio &&
                        value?.codigo !== 'CAR'
                );
                this.tags.push({
                    id: this.municipioData?.id || 0,
                    nome: this.municipioData?.nome + '-' + this.municipioData?.estado?.sigla,
                    codigo: 'MUNICIPIO'
                });
                let filtros = {
                    ...this.filtroState,
                    tipoAgrupamento: 'MUNICIPIO',
                    idsMunicipios: [this.municipioData?.id],
                    objMunicipio: {
                        id: this.municipioData?.id,
                        nome: this.municipioData?.nome
                    },
                    nome: this.municipioData?.nome + '-' + this.municipioData?.estado?.sigla,
                    siglaEstado: this.municipioData?.estado?.sigla,
                    objEstado: this.municipioData?.estado,
                    codigosCars: [],
                    codigosCulturas: this.culturaSelecionada
                };

                this.setFiltroInteligenciaTerritorial(filtros);
                this.atualizarTituloContainerGrafico('MUNICIPIO');
            } else if (conteudoLinhaGraficoClickGrafico && conteudoLinhaGraficoClickGrafico.length >= 43 && CarUtils.isCar(conteudoLinhaGraficoClickGrafico)) {
                this.$router.push({
                    name: 'InteligenciaTerritorialImovel',
                    params: {
                        uf: this.municipioData?.estado?.sigla,
                        codMunicipioIbge: this.municipioData?.id,
                        car: conteudoLinhaGraficoClickGrafico
                    }
                });
            }
        },
        async updateFiltrosClickMapaEstados(uf) {
            await this.buscarEstado(uf);

            this.tags = this.tags.filter(
                value =>
                    value?.codigo !== this.municipio &&
                    value?.codigo !== this.estado &&
                    value?.codigo !== 'CAR'
            );

            this.tags.push({
                id: uf,
                nome: uf,
                codigo: 'ESTADO'
            });

            let filtros = {
                ...this.filtroState,
                tipoAgrupamento: 'ESTADO',
                objEstado: this.estadoData || {},
                siglaEstado: uf,
                idsMunicipios: [],
                codigosCars: [],
                codigosCulturas: this.culturaSelecionada
            };
            this.setFiltroInteligenciaTerritorial(filtros);
            this.atualizarTituloContainerGrafico('ESTADO');
        },

        async updateFiltrosClickMapaMunicipios(idMunicipio) {
            await this.buscarMunicipio(idMunicipio);

            this.tags = this.tags.filter(
                value =>
                    value?.codigo !== this.estado &&
                    value?.codigo !== this.municipio &&
                    value?.codigo !== 'CAR'
            );

            this.tags.push({
                id: this.municipioData?.id || 0,
                nome: this.municipioData?.nome + '-' + this.municipioData?.estado?.sigla,
                codigo: 'MUNICIPIO'
            });

            let filtros = {
                ...this.filtroState,
                tipoAgrupamento: 'MUNICIPIO',
                idsMunicipios: [this.municipioData?.id],
                objMunicipio: {
                    id: this.municipioData?.id,
                    nome: this.municipioData?.nome
                },
                nome: this.municipioData?.nome + '-' + this.municipioData?.estado?.sigla,
                siglaEstado: this.municipioData?.estado?.sigla,
                objEstado: this.municipioData?.estado,
                codigosCars: [],
                codigosCulturas: this.culturaSelecionada
            };

            this.setFiltroInteligenciaTerritorial(filtros);
            this.atualizarTituloContainerGrafico('MUNICIPIO');
        },

        removeDuplicates(arr) {
            const unique = _.uniqBy(arr, obj => obj.codigo);
            return unique;
        },

        selecionarBase(dado, index) {
            if (dado === this.$t('mensagens.inteligenciaTerritorial.base.carteira')) {
                return;
            }
            this.selectedIndex = index;
        },

        exibirNotify(tipo, message) {
            this.$notify[tipo]({
                message
            });
        },

        async buscarMunicipios(estadoId) {
            this.setArrayTodosMunicipiosEstadoInteligenciaTerritorial([]);
            await LocalidadeService.findNivel2(estadoId, false)
                .then(({ data }) => {
                    EventBus.$emit('filtroAvancadoInteligenciaTerritorial:atualizar-lista-municipios', data);
                    this.setArrayTodosMunicipiosEstadoInteligenciaTerritorial(data);
                })
                .catch(error => {
                    this.exibirNotify(
                        'error',
                        'Não foi possível buscar os dados de municipio.'
                    );
                    throw error;
                });
        },

        async globalSetterFiltros(filtro, tipo) {
            this.isLoadingAreaTotal = true;
            this.isLoadingRanking = true;
            if (tipo === this.estado) {
                this.tags = this.tags.filter(
                    value =>
                        value?.codigo !== this.municipio &&
                        value?.codigo !== this.estado &&
                        value?.codigo !== 'CAR'
                );
                this.tags.push({
                    id: filtro?.estadoId,
                    nome: filtro?.siglaEstado,
                    codigo: tipo
                });
                this.estadoId = filtro?.estadoId;
                await this.buscarMunicipios(filtro?.objEstado?.id || this.estadoId);
            }
            if (tipo === this.municipio) {
                this.tags = this.tags.filter(
                    value =>
                        value?.codigo !== this.estado &&
                        value?.codigo !== this.municipio &&
                        value?.codigo !== 'CAR'
                );
                if (filtro?.objMunicipio) {
                    this.tags.push({
                        id: filtro?.objMunicipio.id,
                        nome: filtro?.nome,
                        codigo: tipo
                    });
                } else if (filtro?.municipioSelecionado) {
                    this.tags.push({
                        id: filtro?.municipioSelecionado.id,
                        nome: filtro?.nome,
                        codigo: tipo
                    });
                }
                this.estadoId = filtro?.estadoId;
            }
            if (tipo === 'CAR') {
                this.tags = this.tags.filter(
                    value =>
                        value?.codigo !== this.estado &&
                        value?.codigo !== this.municipio &&
                        value?.codigo !== 'CAR'
                );
                this.tags.push({
                    id: [filtro?.codigo],
                    nome: [filtro?.nomeMunicipio] + '-' + [filtro?.uf],
                    codigo: 'CAR'
                });
            }

            if (filtro?.possuiRestricao !== null && filtro?.possuiRestricao !== undefined) {
                if (filtro?.possuiRestricao === true) {
                    this.tags = this.tags.filter(
                        value => value?.codigo !== 'POSSUI_RESTRICOES' && value?.codigo !== 'NAO_POSSUI_RESTRICOES'
                    );
                    this.tags = [
                        ...this.tags,
                        ...[
                            {
                                nome: this.$t('mensagens.inteligenciaTerritorial.possuiRestricoes'),
                                codigo: 'POSSUI_RESTRICOES'
                            }
                        ]
                    ];
                } else {
                    this.tags = this.tags.filter(
                        value => value?.codigo !== 'NAO_POSSUI_RESTRICOES' && value?.codigo !== 'POSSUI_RESTRICOES'
                    );
                    this.tags = [
                        ...this.tags,
                        ...[
                            {
                                nome: this.$t('mensagens.inteligenciaTerritorial.naoPossuiRestricoes'),
                                codigo: 'NAO_POSSUI_RESTRICOES'
                            }
                        ]
                    ];
                }
            }
            if (filtro?.areaImovelInicial && filtro?.areaImovelInicial.length > 0) {
                let areaImovelInicialTag = null;

                if (filtro?.areaImovelInicial === 'MENOR_50_HA') {
                    areaImovelInicialTag = this.$t('mensagens.inteligenciaTerritorial.areaImovelMaiorQueCinquenta');
                } else if (filtro?.areaImovelInicial === 'ENTRE_50_E_1000_HA') {
                    areaImovelInicialTag = this.$t('mensagens.inteligenciaTerritorial.areaImovelEntreCinquentaMil');
                } else if (filtro?.areaImovelInicial === 'MAIOR_QUE_1000_HA') {
                    areaImovelInicialTag = this.$t('mensagens.inteligenciaTerritorial.areaImovelMaiorQueMil');
                }

                this.tags = this.tags.filter(
                    value => value?.codigo !== 'AI_MENOR_50_HA'
                );
                this.tags = this.tags.filter(
                    value => value?.codigo !== 'AI_ENTRE_50_E_1000_HA'
                );
                this.tags = this.tags.filter(
                    value => value?.codigo !== 'AI_MAIOR_QUE_1000_HA'
                );

                this.tags = [
                    ...this.tags,
                    ...[
                        {
                            nome: areaImovelInicialTag,
                            codigo: `AI_${filtro?.areaImovelInicial}`
                        }
                    ]
                ];
            }
            if (filtro?.areaPlantadaInicial && filtro?.areaPlantadaInicial.length > 0) {
                let areaPlantadaInicialTag = null;

                if (filtro?.areaPlantadaInicial === 'MENOR_50_HA') {
                    areaPlantadaInicialTag = this.$t('mensagens.inteligenciaTerritorial.areaPlantadaMaiorQueCinquenta');
                } else if (
                    filtro?.areaPlantadaInicial === 'ENTRE_50_E_1000_HA'
                ) {
                    areaPlantadaInicialTag = this.$t('mensagens.inteligenciaTerritorial.areaPlantadaEntreCinquentaMil');
                } else if (
                    filtro?.areaPlantadaInicial === 'MAIOR_QUE_1000_HA'
                ) {
                    areaPlantadaInicialTag = this.$t('mensagens.inteligenciaTerritorial.areaPlantadaMaiorQueMil');
                }

                this.tags = this.tags.filter(
                    value => value?.codigo !== 'AP_MENOR_50_HA'
                );
                this.tags = this.tags.filter(
                    value => value?.codigo !== 'AP_ENTRE_50_E_1000_HA'
                );
                this.tags = this.tags.filter(
                    value => value?.codigo !== 'AP_MAIOR_QUE_1000_HA'
                );

                this.tags = [
                    ...this.tags,
                    ...[
                        {
                            nome: areaPlantadaInicialTag,
                            codigo: `AP_${filtro?.areaPlantadaInicial}`
                        }
                    ]
                ];
            }
            if (filtro?.areaPastagemInicial && filtro?.areaPastagemInicial.length > 0) {
                let areaPastagemInicialTag = null;

                if (filtro?.areaPastagemInicial === 'DEGRADACAO_AUSENTE') {
                    areaPastagemInicialTag = this.$t('mensagens.inteligenciaTerritorial.areaDePastagemDegradacaoAusente');
                } else if (
                    filtro?.areaPastagemInicial === 'DEGRADACAO_INTERMEDIARIA'
                ) {
                    areaPastagemInicialTag = this.$t('mensagens.inteligenciaTerritorial.areaDePastagemDegradacaoIntermediaria');
                } else if (
                    filtro?.areaPastagemInicial === 'DEGRADACAO_SEVERA'
                ) {
                    areaPastagemInicialTag = this.$t('mensagens.inteligenciaTerritorial.areaDePastagemDegradacaoSevera');
                }

                this.tags = this.tags.filter(
                    value => value?.codigo !== 'DEGRADACAO_AUSENTE'
                );
                this.tags = this.tags.filter(
                    value => value?.codigo !== 'DEGRADACAO_INTERMEDIARIA'
                );
                this.tags = this.tags.filter(
                    value => value?.codigo !== 'DEGRADACAO_SEVERA'
                );

                this.tags = [
                    ...this.tags,
                    ...[
                        {
                            nome: areaPastagemInicialTag,
                            codigo: filtro?.areaPastagemInicial
                        }
                    ]
                ];
            }
            if (filtro?.codigosCulturas && filtro?.codigosCulturas.length > 0) {
                this.tags = this.tags.filter(
                    value => value?.codigo !== this.cultura
                );
                this.tags = [
                    ...this.tags,
                    ...[
                        {
                            id: this.culturaSelecionada,
                            nome: this.culturaSelecionada,
                            codigo: this.cultura
                        }
                    ]
                ];
                this.tags.push({
                    id: filtro?.codigosCulturas,
                    nome: filtro?.codigosCulturas,
                    codigo: this.cultura
                });
            }

            this.tags = this.removeDuplicates(this.tags);
            this.validacaoBreadcrumb(false);
            this.atualizarTituloContainerGrafico(tipo);
            await this.filtrarAreaTotal();
        },

        async filtrarAreaTotal() {
            this.handleTemFiltrosAvancados();

            let filtroState = {
                ...this.filtroState,
                codigosCulturas: [this.culturaSelecionada] || null
            };
            if (!this.culturaSelecionada || this.culturaSelecionada.length === 0) {
                delete filtroState?.codigosCulturas;
            }

            if (this.filtroState?.tipoAgrupamento === 'MUNICIPIO' || this.temFiltrosAvancados) {
                try {
                    await InteligenciaTerritorialService.filtrarAreaTotalPorCARs(filtroState).then(
                        ({data}) => {
                            if (data.length > 0) {
                                this.areaTotal = data[0];
                            } else {
                                this.areaTotal = {};
                            }
                            this.isLoadingAreaTotal = false;
                        }
                    );
                } catch (error) {
                    this.$notify.error('Ocorreu um erro ao buscar os dados de área total.');
                    this.isLoadingAreaTotal = false;
                }
            } else {
                try {
                    await InteligenciaTerritorialService.filtrarAreaTotalPorMunicipios(filtroState).then(
                        ({data}) => {
                            if (data.length > 0) {
                                this.areaTotal = data[0];
                            } else {
                                this.areaTotal = {};
                            }
                            this.isLoadingAreaTotal = false;
                        }
                    );
                } catch (error) {
                    this.$notify.error('Ocorreu um erro ao buscar os dados de área total.');
                    this.isLoadingAreaTotal = false;
                }
            }
            this.isLoadingAreaTotal = false;
            this.processarTipoRanking();
        },
        processarTipoRanking() {
            this.renomearGraficoProps([]);
            let tipoRanking = '';

            if (
                this.tipoRanking !== 'pastagem' &&
                this.tipoRanking !== 'area-plantada-'
            ) {
                if (this.culturaSelecionada) {
                    tipoRanking =
                        this.tipoRanking +
                        this.culturaSelecionada.toLowerCase();
                    this.controleCulturaMapa = tipoRanking;
                } else {
                    tipoRanking = this.tipoRanking;
                    this.controleCulturaMapa = tipoRanking;
                }
            } else {
                if (this.culturaSelecionada === null) {
                    tipoRanking =
                        this.tipoRanking === 'area-plantada-'
                            ? 'area-plantada'
                            : this.tipoRanking;
                    this.controleCulturaMapa = tipoRanking;
                } else if (this.culturaSelecionada) {
                    if (this.tipoRanking === 'pastagem') {
                        tipoRanking = 'pastagem';
                    } else {
                        tipoRanking =
                            this.tipoRanking +
                            this.culturaSelecionada.toLowerCase();
                        this.controleCulturaMapa = tipoRanking;
                    }
                }
            }

            if (tipoRanking === 'producao-' || tipoRanking === 'producao-soja' || tipoRanking === 'producao-algodao') {
                if (tipoRanking === null) {
                    tipoRanking = this.tipoRanking === 'producao-' ? 'producao' : this.tipoRanking;
                }
                this.controleCulturaMapa = tipoRanking;
                if (this.culturaSelecionada === 'SOJA') {
                    this.controleCulturaMapa = 'producao-soja';
                    tipoRanking = 'producao-soja';
                }
                if (this.culturaSelecionada === 'ALGODAO') {
                    this.controleCulturaMapa = 'producao-algodao';
                    tipoRanking = 'producao-algodao';
                }
            }
            EventBus.$emit('mapaInteligenciaTerritorial:setar-controle-cultura-mapa', tipoRanking || 'pastagem', 1, this.filtroState?.tipoAgrupamento || 'PAIS');
        },

        handleTemFiltrosAvancados() {
            this.temFiltrosAvancados = false;

            if (this.filtroState?.possuiRestricao !== null && this.filtroState?.possuiRestricao !== undefined) {
                this.temFiltrosAvancados = true;
            }
            if (this.filtroState?.areaImovelInicial && this.filtroState?.areaImovelInicial.length > 0) {
                this.temFiltrosAvancados = true;
            }
            if (this.filtroState?.areaPlantadaInicial && this.filtroState?.areaPlantadaInicial.length > 0) {
                this.temFiltrosAvancados = true;
            }
            if (this.filtroState?.areaPastagemInicial && this.filtroState?.areaPastagemInicial.length > 0) {
                this.temFiltrosAvancados = true;
            }
        },

        atualizarTituloContainerGrafico(tipo) {
            let tituloContainerGrafico = this.$t('mensagens.inteligenciaTerritorial.porUf');

            if (tipo === 'ESTADO') {
                tituloContainerGrafico = this.$t('mensagens.inteligenciaTerritorial.porMunicipio');
            } else if (tipo === 'MUNICIPIO') {
                tituloContainerGrafico = this.$t('mensagens.inteligenciaTerritorial.porCar');
            } else tituloContainerGrafico = this.$t('mensagens.inteligenciaTerritorial.porUf');
            this.tituloContainerGrafico = tituloContainerGrafico;
        },

        async voltarVisaoEstadoAposErro(uf) {
            await this.buscarEstado(uf);
            this.tags = this.tags.filter(
                value =>
                    value?.codigo !== this.municipio &&
                    value?.codigo !== this.estado &&
                    value?.codigo !== 'CAR'
            );
            this.tags.push({
                id: uf,
                nome: uf,
                codigo: 'ESTADO'
            });
            let filtros = {
                ...this.filtroState,
                tipoAgrupamento: 'ESTADO',
                objEstado: this.estadoData || {},
                siglaEstado: uf,
                idsMunicipios: [],
                codigosCars: [],
                codigosCulturas: this.culturaSelecionada
            };

            this.setFiltroInteligenciaTerritorial(filtros);
            this.atualizarTituloContainerGrafico('ESTADO');
        },

        renomearGraficoProps(arr) {
            let categorias = [];
            let nameTooltipGrafico = '';

            if (
                this.filtroState?.tipoAgrupamento === 'PAIS' ||
                !this.filtroState?.tipoAgrupamento
            ) {
                categorias = arr.map(item => item?.siglaEstado);
            } else if (this.filtroState?.tipoAgrupamento === 'ESTADO') {
                categorias = this.idsMunicipiosInteligenciaTerritorialRanking;
            } else if (this.filtroState?.tipoAgrupamento === 'MUNICIPIO') {
                categorias = arr.map(item => item?.codigo);
            }

            if (
                this.prefixoTituloContainerGrafico === this.$t('mensagens.inteligenciaTerritorial.rankingAreaPastagem')
            ) {
                nameTooltipGrafico = 'Degradação...';
            } else if (
                this.prefixoTituloContainerGrafico === this.$t('mensagens.inteligenciaTerritorial.rankingAreaAgricultavel')
            ) {
                nameTooltipGrafico = this.$t('mensagens.inteligenciaTerritorial.areaAgricultavel');
            } else if (
                this.prefixoTituloContainerGrafico === this.$t('mensagens.inteligenciaTerritorial.rankingProducao')
            ) {
                nameTooltipGrafico = this.$t('mensagens.inteligenciaTerritorial.producao');
            }

            if (this.tipoRanking !== 'pastagem') {
                let dadosAreaAgricultavel = [];
                if (
                    this.tipoRanking === 'area-plantada-' ||
                    this.tipoRanking === 'area-plantada-soja'
                ) {
                    dadosAreaAgricultavel = [
                        {
                            name: nameTooltipGrafico,
                            data: arr.map(item => item?.total)
                        }
                    ];
                } else if (
                    this.tipoRanking === 'producao-' ||
                    this.tipoRanking === 'producao-soja'
                    ) {
                        let dadosProducao = arr.map(item => item?.total / 1000);
                        dadosAreaAgricultavel = [
                            {
                                name: nameTooltipGrafico,
                                data: dadosProducao
                            }
                    ];
                } else {
                    dadosAreaAgricultavel = [
                        {
                            name: nameTooltipGrafico,
                            data: arr.map(item => item?.total)
                        }
                    ];
                }
                this.dadosRanking = dadosAreaAgricultavel;
                this.categoriasRanking = categorias;
            } else {
                let dadosAreasPastagens = [
                    {
                        name: this.$t('mensagens.inteligenciaTerritorial.degradacaoSevera'),
                        data: []
                    },
                    {
                        name: this.$t('mensagens.inteligenciaTerritorial.degradacaoIntermediaria'),
                        data: []
                    },
                    {
                        name: this.$t('mensagens.inteligenciaTerritorial.degradacaoAusente'),
                        data: []
                    }
                ];
                arr.forEach(item => {
                    dadosAreasPastagens[0].data.push(
                        this.validarValoresNulo(
                            item.areaPastagemDegradacaoSeveraHa
                        )
                    );
                    dadosAreasPastagens[1].data.push(
                        this.validarValoresNulo(
                            item.areaPastagemDegradacaoIntermediariaHa
                        )
                    );
                    dadosAreasPastagens[2].data.push(
                        this.validarValoresNulo(
                            item.areaPastagemDegradacaoAusenteHa
                        )
                    );
                });
                this.dadosRanking = dadosAreasPastagens;
                this.categoriasRanking = categorias;
                this.controleCulturaMapa = 'pastagem';
            }
        },

        validarValoresNulo(valor) {
            return valor === null ? 0 : valor;
        },

        removerTag(tag) {
            this.tags = this.tags.filter(value => value?.codigo !== tag?.codigo);
            let filtros = {};
            if (tag?.codigo === this.municipio) {
                filtros.tipoAgrupamento = this.pais;
                filtros.idsMunicipios = [];
                filtros.codigosCars = [];
            }
            if (tag?.codigo === this.estado) {
                filtros.tipoAgrupamento = this.pais;
                filtros.siglaEstado = null;
                filtros.codigosCars = [];
            }
            if (tag?.codigo === this.cultura) {
                this.removerCultura();
            }
            if (tag?.codigo === 'POSSUI_RESTRICOES' || tag?.codigo === 'NAO_POSSUI_RESTRICOES') {
                filtros.possuiRestricao = null;
            }
            if (
                tag?.codigo === 'AI_MENOR_50_HA' ||
                tag?.codigo === 'AI_ENTRE_50_E_1000_HA' ||
                tag?.codigo === 'AI_MAIOR_QUE_1000_HA'
            ) {
                filtros.areaImovelInicial = null;
            }
            if (
                tag?.codigo === 'AP_MENOR_50_HA' ||
                tag?.codigo === 'AP_ENTRE_50_E_1000_HA' ||
                tag?.codigo === 'AP_MAIOR_QUE_1000_HA'
            ) {
                filtros.areaPlantadaInicial = null;
            }
            if (
                tag?.codigo === 'DEGRADACAO_AUSENTE' ||
                tag?.codigo === 'DEGRADACAO_INTERMEDIARIA' ||
                tag?.codigo === 'DEGRADACAO_SEVERA'
            ) {
                filtros.areaPastagemInicial = null;
            }
            if (tag?.codigo === 'CAR') {
                filtros.codigosCars = [];
                filtros.tipoAgrupamento = this.pais;
            }
            if (this.tags.length === 0) {
                this.limparFiltros();
            }
            filtros = {
                ...this.filtroState,
                ...filtros
            };

            this.setFiltroInteligenciaTerritorial(filtros);
        },

        limparFiltros() {
            this.$store.dispatch('limparFiltroInteligenciaTerritorial');
        },

        validacaoBreadcrumb(inicio) {
            if (this.filtroState?.tipoAgrupamento === this.pais) {
                this.breadcrumb = [
                    { nome: this.$t('mensagens.inteligenciaTerritorial.visaoGeral'), rota: '/inteligencia-territorial' }
                ];
                if (!inicio) {
                    this.$router.push({ path: '/inteligencia-territorial' });
                }
            }
            if (this.filtroState?.tipoAgrupamento === this.estado) {
                this.breadcrumb = [
                    { nome: this.$t('mensagens.inteligenciaTerritorial.visaoGeral'), rota: '/inteligencia-territorial' },
                    {
                        nome: this.$t('mensagens.inteligenciaTerritorial.estadoDepartamento'),
                        rota:
                            '/inteligencia-territorial/' +
                            this.filtroState?.siglaEstado
                    }
                ];
                if (!inicio) {
                    this.$router.push({
                        path:
                            '/inteligencia-territorial/' + this.filtroState?.siglaEstado
                    });
                }
            }
            if (this.filtroState?.tipoAgrupamento === this.municipio) {
                let tagMunicipio = this.tags.filter(
                    value => value?.codigo === this.municipio
                );
                let estado;
                let municipio;
                if (tagMunicipio.length === 1) {
                    this.breadcrumb = [
                        {
                            nome: this.$t('mensagens.inteligenciaTerritorial.visaoGeral'),
                            rota: '/inteligencia-territorial'
                        },
                        {
                            nome: this.$t('mensagens.inteligenciaTerritorial.estadoDepartamento'),
                            rota: '/inteligencia-territorial/' + this.filtroState?.siglaEstado
                        },
                        {
                            nome: this.$t('mensagens.inteligenciaTerritorial.municipioLocalidade'),
                            rota:
                                '/inteligencia-territorial/' +
                                this.filtroState?.siglaEstado +
                                '/' +
                                [this.filtroState?.idsMunicipios]
                        }
                    ];
                    if (!inicio) {
                        this.$router.push({
                            path:
                                '/inteligencia-territorial/' +
                                this.filtroState?.siglaEstado +
                                '/' +
                                [this.filtroState?.idsMunicipios]
                        });
                    }
                } else {
                    let resultado = tagMunicipio[0]?.nome.split('-', 2);
                    municipio = resultado[0];
                    estado = resultado[1];
                    this.breadcrumb = [
                        {
                            nome: this.$t('mensagens.inteligenciaTerritorial.visaoGeral'),
                            rota: '/inteligencia-territorial'
                        },
                        {
                            nome: this.$t('mensagens.inteligenciaTerritorial.estadoDepartamento'),
                            rota: '/inteligencia-territorial/' + estado
                        },
                        {
                            nome: this.$t('mensagens.inteligenciaTerritorial.municipioLocalidade'),
                            rota:
                                '/inteligencia-territorial/' +
                                estado +
                                '/' +
                                [this.filtroState?.idsMunicipios],
                            municipio: municipio
                        }
                    ];
                    if (!inicio) {
                        this.$router.push({
                            path:
                                '/inteligencia-territorial/' +
                                estado +
                                '/' +
                                [this.filtroState?.idsMunicipios]
                        });
                    }
                }
            }
        },

        removerCultura() {
            let filtros = {
                ...this.filtroState,
                codigosCulturas: []
            };
            this.culturaSelecionada = null;
            this.setFiltroInteligenciaTerritorial(filtros);
        },

        mudarDeRota(rota) {
            let filtros = {};
            if (rota.nome === this.$t('mensagens.inteligenciaTerritorial.visaoGeral')) {
                filtros = {
                    ...this.filtroState,
                    tipoAgrupamento: 'PAIS',
                    siglaEstado: null,
                    idsMunicipios: []
                };
                this.tags = this.tags.filter(
                    value =>
                        value?.codigo !== this.estado &&
                        value?.codigo !== this.municipio
                );
            }

            let estado = this.$route.params.uf;
            if (rota.nome === this.$t('mensagens.inteligenciaTerritorial.estadoDepartamento')) {
                filtros = {
                    ...this.filtroState,
                    tipoAgrupamento: 'ESTADO',
                    siglaEstado: estado,
                    idsMunicipios: []
                };
            }
            if (rota.nome === this.$t('mensagens.inteligenciaTerritorial.municipioLocalidade')) {
                let municipio = this.$route.params.municipio;
                filtros = {
                    ...this.filtroState,
                    tipoAgrupamento: 'MUNICIPIO',
                    idsMunicipios: [municipio],
                    nome: rota.municipio + '-' + estado,
                    siglaEstado: estado
                };
            }

            this.setFiltroInteligenciaTerritorial(filtros);
        },

        async atualizarFiltroInicio(tipo) {
            let filtros = {};
            if (this.$route?.params?.uf && !this.$route?.params?.municipio) {
                await this.buscarEstado(this.$route?.params?.uf);
                filtros = {
                    ...this.filtroState,
                    tipoAgrupamento: 'ESTADO',
                    siglaEstado: this.$route?.params?.uf,
                    estadoId: this.estadoData?.id,
                    objEstado: this.estadoData,
                    idsMunicipios: [],
                    codigosCars: []
                };

                this.tags = this.tags.filter(
                    value =>
                        value?.codigo !== this.municipio &&
                        value?.codigo !== this.estado &&
                        value?.codigo !== 'CAR'
                );
                this.tags.push({
                    id: filtros?.estadoId,
                    nome: filtros?.siglaEstado,
                    codigo: tipo
                });
                this.estadoId = this.estadoData?.id;
            } else if (this.$route?.params?.uf && this.$route?.params?.municipio) {
                await this.buscarEstado(this.$route?.params?.uf);
                await this.buscarMunicipio(this.$route?.params?.municipio);
                filtros = {
                    ...this.filtroState,
                    tipoAgrupamento: 'MUNICIPIO',
                    idsMunicipios: [this.$route?.params?.municipio],
                    nome:
                        this.municipioData?.nome +
                        '-' +
                        this.municipioData?.estado?.sigla,
                    objMunicipio: {
                        id: this.municipioData?.id,
                        nome: this.municipioData?.nome
                    },
                    siglaEstado: this.$route?.params?.uf || null,
                    estadoId: this.estadoData?.id,
                    objEstado: this.estadoData,
                    codigosCars: []
                };

                this.tags = this.tags.filter(
                    value =>
                        value?.codigo !== this.estado &&
                        value?.codigo !== this.municipio &&
                        value?.codigo !== 'CAR'
                );
                if (filtros?.objMunicipio) {
                    this.tags.push({
                        id: filtros?.objMunicipio?.id,
                        nome: filtros?.nome,
                        codigo: tipo
                    });
                } else if (filtros?.municipioSelecionado) {
                    this.tags.push({
                        id: filtros?.objMunicipio?.id,
                        nome: filtros?.nome,
                        codigo: tipo
                    });
                }
                this.estadoId = filtros.estadoId;
            }
            this.tags = this.removeDuplicates(this.tags);
            this.validacaoBreadcrumb(true);
            this.atualizarTituloContainerGrafico(tipo);
            this.setFiltroInteligenciaTerritorial(filtros);
        },

        async buscarMunicipio(id) {
            try {
                await MunicipioService.getMunicipioById(id).then(({ data }) => {
                    this.municipioData = data;
                    return data.id;
                });
            } catch (e) {
                return '';
            }
        },
        async buscarEstado(uf) {
            try {
                await LocalidadeService.findNivel1(1).then(
                    ({ data }) => {
                        let estados = data;
                        estados.filter(item => {
                            if (item.sigla === uf) {
                                this.estadoData = item;
                            }
                        });
                    }
                );
            } catch (e) {
                return '';
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.inteligencia-territorial {
    .view-container-base-header {
        padding: 20px;
        height: calc(100vh - 152px);
        overflow-y: auto;

        .inteligencia-territorial-container {
            .inteligencia-territorial-container__container {
                margin: 18px 5px 10px 5px;

                h3 {
                    margin-bottom: 10px;
                    margin-top: 10px;
                }

                .inteligencia-territorial-container__lista {
                    display: flex;
                    flex-wrap: wrap;
                    justify-content: space-between;
                    align-items: center;

                    .inteligencia-territorial-container__lista-item {
                        width: 32.5%;

                        &:last-child {
                            margin: 2px 0px;
                        }
                    }
                }
            }

            .el-button--default:focus {
                border-color: var(--secondary-two);
                color: var(--white) !important;
                background: var(--secondary-two);
                outline: none;
            }

            h3 {
                margin-bottom: 10px;
                margin-top: 15px;
                color: #3b3b3b;
                font-weight: 600;
            }

            .el-button.is-round {
                margin: 2px 3px 0px 2px;
            }

            .el-button.is-round:not(:first-child) {
                margin: 2px 3px 2px 2px;
            }

            .el-button.is-round {
                box-shadow: 0px 0px 2px 0px var(--block-shadow);
                border-radius: 20px;
                padding: 9px 20px;
                min-width: 149px;
                color: var(--primary);
            }
        }

        .inteligencia-territorial-container__button----active {
            border-color: var(--secondary-two) !important;
            color: var(--white) !important;
            background: var(--secondary-two) !important;
        }

        .alert-dados-safra {
            margin-top: 12px;
            display: flex;
            flex-direction: row;

            i {
                font-size: 22px;
                color: var(--black);
            }

            span {
                font-size: 15px;
                color: var(--black);
            }

            .textoSafra {
                font-size: 17px;
                padding: 3px;
            }

            .el-alert__content {
                width: 400px;
            }

            .el-alert--info.is-light {
                background-color: #fdf1c9;
                border-radius: 5px;
                padding: 8px 0px;
            }

            .el-alert .el-alert__description {
                width: 400px !important;
            }
        }
    }

    h3 {
        margin-bottom: 10px;
        margin-top: 10px;
        color: #3b3b3b;
        font-size: 16px;
        font-weight: 600;
    }

    .secao-container--conteudo {
        margin-top: 20px;

        .inteligencia-territorial-container__container {
                margin: 20px 5px 10px 5px !important;
            }
    }

    .secao-container--conteudo--interno {
        display: flex;
        justify-content: start;
        gap: 10px;
        margin-top: 7px;

        #culturaSelecionadaSoja {
            opacity: 0;
        }
    }

    .inteligencia-territorial-container__container {
        margin: 8px 5px 10px 5px;

        h3 {
            margin-bottom: 10px;
            margin-top: 10px;
            color: var(--black);
        }
    }

    .inteligencia-territorial-container__lista {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        align-items: center;
    }

    .inteligencia-territorial-container__lista-item {
        max-height: 540px;
        width: 32.5%;

        &:last-child {
            margin: 2px 0px;
        }
    }

    .bloco-selecao-cultura__titulo
        > div.bloco-selecao-cultura__titulo-icone
        > label
        > span.el-radio__label {
        display: none;
    }

    .filtrar-inteligencia-territorial-container {
        display: flex;
        justify-content: space-between;

        .filtrar-inteligencia-territorial__button {
            .el-popover {
                padding: 15px;
            }
        }
    }

    h3 {
        margin-bottom: 10px;
        margin-top: 10px;
        color: #3b3b3b;
        font-size: 16px;
        font-weight: 600;
    }

    .secao-container--conteudo {
        margin-top: 20px;
    }

    .secao-container--conteudo--interno {
        display: flex;
        justify-content: start;
        gap: 10px;
        margin-top: 7px;

        #culturaSelecionadaSoja {
            opacity: 0;
        }
    }
    .inteligencia__mapa {
        width: 95%;
        height: 520px;
        border-radius: 5px;
        overflow: hidden;
        box-shadow: 0px 1px 5px 0px var(--block-shadow);
        margin-bottom: 14px;
    }
    .inteligencia-territorial-container__container {
        margin: 8px 5px 10px 5px;

        h3 {
            margin-bottom: 10px;
            margin-top: 10px;
            color: var(--black);
        }
        .linha__divisoria {
            display: flex;
            width: 100%;
        }
    }

    .inteligencia-territorial-container__lista {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        align-items: center;
    }

    .inteligencia-territorial-container__lista-item {
        max-height: 540px;
        width: 32.5%;

        &:last-child {
            margin: 2px 0px;
        }
    }

    .bloco-selecao-cultura__titulo
        > div.bloco-selecao-cultura__titulo-icone
        > label
        > span.el-radio__label {
        display: none;
    }

    .filtrar-inteligencia-territorial-container {
        display: flex;
        justify-content: space-between;

        .filtrar-inteligencia-territorial__button {
            .el-popover {
                padding: 15px;
            }
        }
    }
}
</style>
